import { Component, Input, OnInit } from '@angular/core';
import { BaseModal } from '@ui-app/modals/base-modal';
import { EmployeeDataAccessService } from '../../core/services/data-access.service';

interface IDeliveryLocationOption {
    key: number;
    value: string;
}

@Component({
    selector: 'employee-location-change-modal',
    templateUrl: './location-change-modal.component.html',
    styleUrls: ['./location-change-modal.component.less']
})
export class ChangeLocationModalComponent extends BaseModal implements OnInit {

    @Input() popupTitle = 'Change delivery location';
    @Input() buttonsTitle = {
        dismiss: 'Cancel',
        confirm: 'Save'
    };
    @Input() currentDeliverySiteId: number;
    @Input() userId: string;
    @Input() badgeRequestIds: number[];

    readonly minQueryLength: number = 1;
    readonly notValidLocationNames: string[] = ['No name (US)', 'No name (USI)'];
    deliveryLocationOptions: IDeliveryLocationOption[];
    newDeliveryLocation: IDeliveryLocationOption = { key: null, value: '' };
    filterQuery: string = '';
    pipeFilterQuery: string = '';
    isLocationDropdownOpen: boolean = false;
    filterBy: Record<string, string> = null;

    constructor(
        private employeeDataAccessService: EmployeeDataAccessService
    ) {
        super();
    }

    ngOnInit(): void {
        this.getFilteredDeliveryLocationOptions();
    }

    getFilteredDeliveryLocationOptions(): void {
        /**
         * Badge requests grid / change site
         */
        if (this.userId) {
            this.employeeDataAccessService.badgeRequestsService.getDeliveryLocationByEmployeeList(this.userId)
                .subscribe({
                    next: deliveryLocations => {
                        this.deliveryLocationOptions = deliveryLocations.reduce((res, site) => {
                            if (!this.notValidLocationNames.includes(site.siteName) && site.siteId !== this.currentDeliverySiteId) {
                                res.push({ key: site.siteId, value: site.siteName });
                            }
                            return res;
                        }, []);
                    }
                });
        /**
         * Photo review grid / bulk change site
         */
        } else if (this.badgeRequestIds?.length > 0) {
            this.employeeDataAccessService.photoReviewService.getSitesForBulkChangeSite({ badgeRequestIds: this.badgeRequestIds })
            .subscribe({
                next: deliveryLocations => {
                    this.deliveryLocationOptions = deliveryLocations
                        .map(({ siteId, siteName }) => ({ key: siteId, value: siteName }));
                },
                error: () => {
                    this.deliveryLocationOptions = [];
                }
            });
        }
    }

    locationChanged(location: IDeliveryLocationOption): void {
        this.newDeliveryLocation = location;
    }

    setFilterQuery(query: string): void {
        const trimmedQuery: string = query.trim();
        if (!trimmedQuery.length) {
            this.filterQuery = '';
            this.pipeFilterQuery = '';
        }

        this.pipeFilterQuery = (trimmedQuery.length < this.minQueryLength) ? '' : trimmedQuery;
        this.filterBy = this.pipeFilterQuery.length ? { value: this.pipeFilterQuery } : null;
    }

    toggle(): void {
        this.isLocationDropdownOpen = !this.isLocationDropdownOpen;
    }

    get hasFilteredResults(): boolean {
        return (this.pipeFilterQuery.length === 0)
            ? this.deliveryLocationOptions.length > 0
            : this.deliveryLocationOptions
                .some(option => option.value.toLowerCase().includes(this.pipeFilterQuery.toLowerCase()));
    }

    submit(): void {
        this.action(this.newDeliveryLocation.key);
    }

}
